import { useState, useEffect } from 'react';

const LS_KEY = 'modulum_pwa_no_prompt';

// Capture beforeinstallprompt globally (called from index.html inline script)
// We also listen here in case it fires after mount
export default function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(() => (window as any).__modulum_deferredPrompt || null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if ((window as any).__modulum_deferredPrompt && !localStorage.getItem(LS_KEY)) {
      setShow(true);
    }
    const handler = () => {
      const prompt = (window as any).__modulum_deferredPrompt;
      if (prompt) {
        setDeferredPrompt(prompt);
        if (!localStorage.getItem(LS_KEY)) setShow(true);
      }
    };
    window.addEventListener('modulum-install-ready', handler);
    return () => window.removeEventListener('modulum-install-ready', handler);
  }, []);

  async function install() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      (window as any).__modulum_deferredPrompt = null;
      setDeferredPrompt(null);
    }
    setShow(false);
  }

  function dismiss(permanent: boolean) {
    if (permanent) localStorage.setItem(LS_KEY, '1');
    setShow(false);
  }

  if (!show || !deferredPrompt) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(20,35,63,.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20,
    }}
      onClick={() => dismiss(false)}
    >
      <div style={{
        background: '#fff', borderRadius: 16, padding: '32px 28px',
        maxWidth: 360, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,.25)',
        textAlign: 'center',
      }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ marginBottom: 16 }}>
          <svg width="48" height="48" viewBox="0 0 100 100" style={{ display: 'block', margin: '0 auto' }}>
            <path d="M16 88 L16 40 L50 64" fill="none" stroke="#14233F" strokeWidth="14" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M50 64 L84 16 L84 64" fill="none" stroke="#F47B20" strokeWidth="14" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div style={{ fontWeight: 800, fontSize: 18, color: '#14233F', marginBottom: 8 }}>
          Telepítsd a Modulum appot
        </div>
        <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6, marginBottom: 24 }}>
          Add a kezdőképernyőhöz a gyors eléréshez. Értesítéseket is kapsz fontos eseményekről.
        </div>
        <button onClick={install}
          style={{
            width: '100%', background: '#F47B20', color: '#fff', border: 'none',
            borderRadius: 10, padding: '13px', fontWeight: 700, fontSize: 15,
            cursor: 'pointer', marginBottom: 10,
          }}>
          Telepítés
        </button>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => dismiss(false)}
            style={{ flex: 1, background: 'transparent', border: '1.5px solid var(--line, #dde2ec)', borderRadius: 10, padding: '10px', fontSize: 13, color: '#6b7280', cursor: 'pointer' }}>
            Később
          </button>
          <button onClick={() => dismiss(true)}
            style={{ flex: 1, background: 'transparent', border: '1.5px solid var(--line, #dde2ec)', borderRadius: 10, padding: '10px', fontSize: 13, color: '#6b7280', cursor: 'pointer' }}>
            Ne mutasd többé
          </button>
        </div>
      </div>
    </div>
  );
}

export function usePwaInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(() => (window as any).__modulum_deferredPrompt || null);

  useEffect(() => {
    const handler = () => setDeferredPrompt((window as any).__modulum_deferredPrompt || null);
    window.addEventListener('modulum-install-ready', handler);
    return () => window.removeEventListener('modulum-install-ready', handler);
  }, []);

  async function promptInstall() {
    const prompt = deferredPrompt || (window as any).__modulum_deferredPrompt;
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    (window as any).__modulum_deferredPrompt = null;
    setDeferredPrompt(null);
  }

  return {
    canInstall: !!(deferredPrompt || (window as any).__modulum_deferredPrompt),
    promptInstall,
  };
}
